import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import withBranchHOC from "../Hoc/BranchHOC";
import STRINGS from "../Constants/Strings";
import { BranchSignin } from "./BranchSignin";
import {
  ERROR_CODE,
  HTTP_STATUS,
  S_ACCOUNT_ID,
  S_CURRENT_MEMBER_ID,
  S_CURRENT_MEMBER_NAME,
  S_STAFF_ID,
  S_TOKEN_USER,
  TOKEN_KEY,
  USER_ROLE,
} from "../Communication/Constants";
import { doSignin } from "../Components/Signin/Actions/SigninAction";
import doCheckExistingUser from "../Components/Register/Actions/ExistingUserActions";
import * as ROUTES from "../Constants/Routes";
import OtpModal from "./OtpModal";
import {
  removeBranchIdentifiers,
  removeStaffIdentifiers,
  removeUserIdentifiers,
} from "../Utils/CommonUtilities";
import { getLoanProduct } from "../Components/LoanDetails/Actions/LoanDetailsAction";
import {
  getFIInfo,
  getProductList,
} from "../Components/MarketPlace/Action/MarketPlaceAction";
import { doGetProvinceList } from "../Components/AboutYou/Actions/AboutYouActions";
import { getApplicantType } from "../Components/JointApplicant/Actions/JointApplicantAction";
import {
  getOccupationCodes,
  getReasonCodes,
} from "../Redux/Actions/ApplicationAction";

class BranchSigninContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doSignInWithOtp: false,
      otpId: null,
      verifyingUser: false,
      verifyDisabled: true,
      email: null,
      password: null,
      errors: {
        authCode: null,
      },
    };
  }

  componentDidMount() {
    console.log("BranchSigninContainer");
    const { history } = this.props;
    if (sessionStorage.getItem(TOKEN_KEY)) {
      history.push("/");
    } else {
      removeBranchIdentifiers();
      removeStaffIdentifiers();
    }
  }

  handleSignin = (userDetails) => {
    const {
      doSignIn,
      doCheckExistingUser: checkExistingUser,
      history,
      doGetProductList,
      doGetLoanProduct,
      doGetFinInfo,
      doGetProvinceList,
      doGetApplicantType,
      doGetOccupationCodes,
      doGetReasonCodes,
    } = this.props;
    const { doSignInWithOtp, errors } = this.state;
    console.log("handleSignin", userDetails);
    if (doSignInWithOtp) {
      this.setState({ verifyingUser: true }, () => {
        doSignIn(userDetails, (response) => {
          console.log("login", response);
          if (response.status === HTTP_STATUS.OK) {
            removeBranchIdentifiers();
            sessionStorage.setItem(S_STAFF_ID, response.data.id);
            doGetProductList();
            doGetLoanProduct();
            doGetFinInfo();
            doGetProvinceList();
            doGetApplicantType();
            doGetOccupationCodes();
            doGetReasonCodes();
            history.push(ROUTES.SMART_BRANCH_DASHBOARD);
          } else if (response.data?.code === ERROR_CODE.OTP_EXPIRES) {
            this.setState({
              verifyingUser: false,
              errors: {
                ...errors,
                authCode: null,
              },
            });
          } else if (response.data?.code === ERROR_CODE.OTP_INVALID) {
            this.setState({
              verifyingUser: false,
              errors: {
                ...errors,
                authCode: [STRINGS.BRANCH.SIGNIN.ERROR_MESSAGES.OTP_INVALID],
              },
            });
          } else {
            this.setState({
              doSignInWithOtp: false,
              verifyingUser: false,
              errors: {
                ...errors,
                authCode: null,
              },
            });
            removeBranchIdentifiers();
            sessionStorage.removeItem(S_ACCOUNT_ID);
          }
        });
      });
    } else {
      checkExistingUser({ ...userDetails, authCheck: true }, (res) => {
        if (res.data.existing) {
          this.setState({
            doSignInWithOtp: true,
            errors: {
              ...errors,
              authCode: null,
            },
            email: userDetails.credential,
            password: userDetails.password,
            otpId: res.data.otpId,
          });
        }
      });
    }
  };

  handleVerify = (authCode) => {
    const { email, password, otpId } = this.state;
    this.handleSignin({
      credential: email,
      password,
      otp: authCode,
      authCheck: false,
      otpId,
      bankingType: "staff",
    });
  };

  toggleModal = (isShow = false) => {
    this.setState({
      doSignInWithOtp: isShow,
    });
  };

  resendCode = () => {
    console.log("resendCode");
    const { doCheckExistingUser: checkExistingUser } = this.props;
    const { email, password } = this.state;
    checkExistingUser(
      {
        credential: email,
        password,
        authCheck: true,
      },
      (res) => {
        if (res.data.existing) {
          this.setState({
            otpId: res.data.otpId,
          });
        }
      }
    );
  };

  render() {
    const { finInfo } = this.props;
    const {
      doSignInWithOtp,
      errors,
      verifyingUser,
      verifyDisabled,
    } = this.state;
    return (
      <>
        <BranchSignin finInfo={finInfo} handleSignin={this.handleSignin} />
        <OtpModal
          show={doSignInWithOtp}
          onHide={this.toggleModal}
          verifyingUser={verifyingUser}
          onVerify={this.handleVerify}
          onResendCode={this.resendCode}
          errors={errors}
          verifyDisabled={verifyDisabled}
          onAuthCodeChange={(authCode) => {
            this.setState({
              verifyDisabled: !authCode,
            });
          }}
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      doSignIn: doSignin,
      doCheckExistingUser,
      doGetLoanProduct: getLoanProduct,
      doGetFinInfo: getFIInfo,
      doGetProvinceList,
      doGetApplicantType: getApplicantType,
      doGetOccupationCodes: getOccupationCodes,
      doGetReasonCodes: getReasonCodes,
      doGetProductList: getProductList,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  finInfo: state.MarketplaceReducer.finInfo,
});

BranchSigninContainer.propTypes = {
  doSignIn: PropTypes.func.isRequired,
  doCheckExistingUser: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  finInfo: PropTypes.shape({}),
};

BranchSigninContainer.defaultProps = {
  finInfo: null,
};

const BranchSigninContainerWithConnect = withBranchHOC(BranchSigninContainer);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BranchSigninContainerWithConnect);
